export default __webpack_public_path__ + "static/media/flag-curacao.729cb2fb.svg";